import { render, staticRenderFns } from "./ShopCards.vue?vue&type=template&id=0646a4b6&scoped=true&"
import script from "./ShopCards.vue?vue&type=script&lang=js&"
export * from "./ShopCards.vue?vue&type=script&lang=js&"
import style0 from "./ShopCards.vue?vue&type=style&index=0&id=0646a4b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0646a4b6",
  null
  
)

export default component.exports